import type { TableCommandFactory } from 'components/Table/model/TableModel';

type SetContentHeightCommand = {
  height: number;
};

export const setContentHeight: TableCommandFactory<SetContentHeightCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.contentHeight = command.height;
    });
  };
